import { z } from "zod";

const translationPath = "page.settings.schedule.tasySchedMenu.errors.";

const emptyHtmlRegex = /<[^>]*>/g;

const hasContent = (value?: string | null) => {
  if (!value) return false;

  const normalizedValue = value
    .replace(emptyHtmlRegex, "")
    .replace(/&nbsp;/g, " ")
    .trim();

  return normalizedValue.length > 0;
};

const ticketAutomationReceivedRuleSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.union([z.string(), z.number()]).optional(),
  },
  {
    invalid_type_error: translationPath + "ticket_automation_received_rule",
  }
);

export const tasySchedMenuSchema = z
  .object({
    id: z.string().optional(),
    ticketAutomationReceivedRule: ticketAutomationReceivedRuleSchema
      .optional()
      .nullable(),
    name: z.string().min(1, translationPath + "name"),
    customMessage: z.string().optional().nullable(),
    displayOrder: z.string().min(1, translationPath + "display_order"),
  })
  .superRefine((data, ctx) => {
    const hasRule = !!data.ticketAutomationReceivedRule?.id;
    const hasCustomMessage = hasContent(data.customMessage);

    if (hasRule && hasCustomMessage) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: translationPath + "custom_message_with_rule",
        path: ["customMessage"],
      });

      return;
    }

    if (hasRule || hasCustomMessage) {
      return;
    }

    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: translationPath + "rule_or_custom_message",
      path: ["ticketAutomationReceivedRule"],
    });

    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: translationPath + "rule_or_custom_message",
      path: ["customMessage"],
    });
  });

export type TTasySchedMenuForm = z.infer<typeof tasySchedMenuSchema>;
